import React from 'react';
import './quotation.css';

const quotations = [
  {
    id: 1,
    author: 'Albert Einstein',
    quote: 'Life is like riding a bicycle. To keep your balance you must keep moving.',
  },
  {
    id: 2,
    author: 'Steve Jobs',
    quote: 'Your work is going to fill a large part of your life, and the only way to be truly satisfied is to do what you believe is great work.',
  },
  {
    id: 3,
    author: 'Mahatma Gandhi',
    quote: 'Be the change that you wish to see in the world.',
  },
  {
    id: 4,
    author: 'Aman Gupta',
    quote: 'Innovation distinguishes between a leader and a follower.',
  },
];

const Quotation = () => {
  return (
    <div className="quotation-container">
      <h2>Inspirational Quotations</h2>
      <div className="quotation-grid">
        {quotations.map((q) => (
          <div key={q.id} className="quotation-card">
            <p className="quote">"{q.quote}"</p>
            <h3 className="author">- {q.author}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Quotation;
